export const kpiData = [
  {name: 'ValidationSpeed', type: 1, translationKey: 'debtor.dashboard.kpis.validationScore', walkme: 'ddashboard-kpis-validationScore'},
  {name: 'AverageOverdueDays', type: 2, translationKey: 'debtor.dashboard.kpis.averageOverdueDays', walkme: 'ddashboard-kpis-averageOverdueDays'},
  {name: 'PaymentSpeed', type: 1, translationKey: 'debtor.dashboard.kpis.paymentSpeed', walkme: 'ddashboard-kpis-paymentSpeed'},
  {name: 'ResponsivenessScore', type: 1, translationKey: 'debtor.dashboard.kpis.responsivenessScore', walkme: 'ddashboard-kpis-responsivenessScore'}
];
